import * as Immutable from "immutable";
import useQueryFilters from "views/logic/queries/useQueryFilters";
import { filtersToStreamSet } from "views/logic/queries/Query";
import { createGRN } from "logic/permissions/GRN";
import useCurrentQuery from "views/logic/queries/useCurrentQuery";
const useSelectedStreamsGRN = () => {
  const queryFilters = useQueryFilters();
  const currentQuery = useCurrentQuery();
  const streams = filtersToStreamSet(queryFilters.get(currentQuery.id, Immutable.Map())).toJS();
  const selectedStreamsGRN = streams == null ? void 0 : streams.map((stream) => createGRN("stream", stream));
  return { selectedStreamsGRN };
};
export default useSelectedStreamsGRN;
